/*******************************************************************************
* @ngdoc   service
* @module  books.ui.budgets
* @name    books.ui.budgets.service:budgets
*
* @description 
* Service object for communicating with the budgetsController on the server.
*******************************************************************************/
/* @ngInject */ export function BudgetServices(HTTPService) {
  var http = HTTPService.make('/books/budgets/');

  this.deleteBudget = (id) => http.get(`deleteBudget/${id}`);
  this.getAccounts = () => http.get('getAccounts');
  this.getCashBalanceForward = (fy) =>
    http.get(`getCashBalanceForward/${fy}`);
  this.getClassInfoList = () => http.get('getClassInfoList');
  this.getFYMonth = () => http.get('getFYMonth');
  this.getOrganization = () => http.get('getOrganization');
  this.viewBudgetItems = (id) => http.get(`viewBudgetItems/${id}`);
  this.viewBudgets = () => http.get('viewBudgets');

  this.saveBudget = (id, fy, items) =>
    http.post('saveBudget', {
      budgetID: id,
      fiscalYear: fy,
      items: items
    });
}
